export const PAGE_ACCESS_SUPER = '012539';
export const ALL_SUBJECTS = '*';

export const SUBJECT_TYPES = [
  { value: 'branch', label: 'สาขา', orgField: 'level2' },
  { value: 'division', label: 'ฝ่าย', orgField: 'level3' },
  { value: 'department', label: 'แผนก', orgField: 'level4' },
  { value: 'position', label: 'ตำแหน่ง', orgField: 'level5' },
  { value: 'employee', label: 'บุคคล', orgField: null },
];

const ORG_FIELD = {
  branch: 'level2',
  division: 'level3',
  department: 'level4',
  position: 'level5',
};

const LOW_RANKS = new Set(['Trainee', 'Staff', 'Senior I', 'Senior II', 'Senior III']);
const OT_BLOCKED_RANKS = new Set(
  [
    'Trainee',
    'Staff',
    'Senior I',
    'Senior II',
    'Senior III',
    'Supervisor',
    'Head',
    'Management Trainee',
    'Assistant Manager',
    'พนักงานฝึกหัด',
    'พนักงานทั่วไป',
    'พนักงานอาวุโสระดับ 1',
    'พนักงานอาวุโสระดับ 2',
    'พนักงานอาวุโสระดับ 3',
    'หัวหน้างาน',
    'ผู้จัดการฝึกหัด',
    'ผู้ช่วยผู้จัดการ',
  ].map((r) => r.toLowerCase())
);

export const PAGE_CATALOG = [
  {
    group: 'ข้อมูลพนักงาน',
    items: [
      { key: 'manageUser', label: 'ข้อมูลพนักงาน', paths: ['/manageUser'] },
      { key: 'consent', label: 'ข้อมูลส่วนบุคคลของพนักงาน', paths: ['/consent'] },
      { key: 'manageHealth', label: 'สุขภาพพนักงาน', paths: ['/manageHealth'] },
      { key: 'manageWelfare', label: 'ค่าเสียหาย + เงินค้ำ', paths: ['/manageWelfare'] },
      { key: 'promoteCandidate', label: 'รับเข้าพนักงาน', paths: ['/promoteCandidate'] },
      { key: 'prepareAssignAsset', label: 'เตรียมอุปกรณ์พนักงาน', paths: ['/prepareAssignAsset'] },
    ],
  },
  {
    group: 'การจัดการ',
    items: [
      { key: 'manageDept', label: 'จัดการองค์กร', paths: ['/manageDept'] },
      { key: 'manageAdOrganization', label: 'จัดการ AD', paths: ['/manageAdOrganization'] },
      { key: 'manageAssets', label: 'จัดการสินทรัพย์', paths: ['/manageAssets'] },
      { key: 'baiboonAdmin', label: 'น้องใบบุญ (Admin)', paths: ['/baiboonAdmin'] },
      { key: 'manageChatId', label: 'ตั้งค่า chatId', paths: ['/manageChatId'] },
    ],
  },
  {
    group: 'ประเมิน (ชุด HR)',
    items: [
      {
        key: 'evaluation.hr',
        label: 'เมนูประเมินของ HR (ไม่รวมของฉัน)',
        paths: [
          '/probationEva',
          '/probationEvaYear',
          '/summaryProbationEvaYear',
          '/summaryKpiProbationEvaYear',
          '/behaviorDisciplineEvaYear',
          '/evaluationSkillGap',
          '/talentNineBox',
          '/evaluationOkr',
          '/evaluationPeerSummary',
          '/evaluationRetention',
          '/settingTest',
        ],
      },
    ],
  },
  {
    group: 'สมัครงาน',
    items: [
      { key: 'listRecruit', label: 'รายการคำร้องขอสมัครงาน', paths: ['/listRecruit'] },
      { key: 'manageTest', label: 'จัดการข้อสอบ', paths: ['/manageTest'] },
      { key: 'candidateEvaluation', label: 'ประเมินผู้สมัครงาน', paths: ['/candidateEvaluation'] },
      { key: 'deptOpen', label: 'ตำแหน่งที่เปิดรับสมัคร', paths: ['/deptOpen'] },
      { key: 'applicationArchive', label: 'คลังใบสมัคร', paths: ['/applicationArchive'] },
      { key: 'reqEmployee', label: 'ร้องขอกำลังพล', paths: ['/reqEmployee'] },
      { key: 'approveReqList', label: 'อนุมัติคำร้องกำลังพล', paths: ['/approveReqList'] },
    ],
  },
  {
    group: 'อื่นๆ',
    items: [{ key: 'otCosting', label: 'OT Costing', paths: ['/otCosting'] }],
  },
];

export const PAGE_KEYS = PAGE_CATALOG.flatMap((g) => g.items.map((i) => i.key));
const PAGE_KEY_SET = new Set(PAGE_KEYS);

export const PAGE_PATH_TO_KEY = Object.fromEntries(
  PAGE_CATALOG.flatMap((g) => g.items.flatMap((i) => i.paths.map((p) => [p, i.key])))
);

export function parseOrg(emp) {
  const raw = emp?.organization;
  if (!raw) return {};
  if (typeof raw === 'object') return raw;
  try {
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

export function isPageAccessAdmin(emp) {
  if (!emp) return false;
  if (String(emp.employeeCode || '').trim() === PAGE_ACCESS_SUPER) return true;
  const o = parseOrg(emp);
  return o.level4 === 'ทรัพยากรบุคคล' || o.level5 === 'ทรัพยากรบุคคล';
}

function isHr(emp) {
  return parseOrg(emp).level5 === 'ทรัพยากรบุคคล';
}

function isItDivision(emp) {
  return parseOrg(emp).level4 === 'เทคโนโลยีและสารสนเทศ';
}

function isSuper(emp) {
  return String(emp?.employeeCode || '').trim() === PAGE_ACCESS_SUPER;
}

function isHighRankReq(emp) {
  return !LOW_RANKS.has(String(emp?.rank || '').trim());
}

function isEvalHrDept(emp) {
  const o = parseOrg(emp);
  return o.level4 === 'ทรัพยากรบุคคล' || o.level5 === 'ทรัพยากรบุคคล';
}

function canAccessOtCostingPage(emp) {
  if (!emp) return false;
  const rank = String(emp.rank || '')
    .trim()
    .split('(')[0]
    .trim()
    .toLowerCase();
  if (!rank) return true;
  return !OT_BLOCKED_RANKS.has(rank);
}

/** Baseline ที่ hardcode อยู่ใน nav / หน้า — ACL เปิดเพิ่มทับอันนี้ */
export function isHardcodedAllowed(emp, pageKey) {
  if (!emp || !pageKey) return false;
  switch (pageKey) {
    case 'manageUser':
    case 'consent':
    case 'manageHealth':
    case 'promoteCandidate':
    case 'manageTest':
      return isHr(emp);
    case 'manageWelfare':
      return isHr(emp) || canAccessOtCostingPage(emp);
    case 'prepareAssignAsset':
      return isItDivision(emp) || parseOrg(emp).level5 === 'เจ้าหน้าที่ทรัพยากรบุคคล';
    case 'manageDept':
    case 'deptOpen':
    case 'applicationArchive':
      return isHr(emp) || isSuper(emp);
    case 'manageAdOrganization':
    case 'manageAssets':
    case 'manageChatId':
      return isHr(emp) || isItDivision(emp) || isSuper(emp);
    case 'baiboonAdmin':
      return isHr(emp) || isItDivision(emp) || isSuper(emp) || String(emp.employeeCode || '').trim() === '001005';
    case 'evaluation.hr':
      return isEvalHrDept(emp);
    case 'listRecruit':
    case 'candidateEvaluation':
      return isHr(emp) || Boolean(emp?.isRecruiter);
    case 'reqEmployee':
    case 'approveReqList':
      return isHighRankReq(emp) || isHr(emp) || isSuper(emp);
    case 'otCosting':
      return canAccessOtCostingPage(emp);
    default:
      return false;
  }
}

export function subjectValues(emp, subjectType) {
  if (!emp) return [];
  if (subjectType === 'employee') {
    const code = String(emp.employeeCode || '').trim();
    return code ? [code] : [];
  }
  const field = ORG_FIELD[subjectType];
  if (!field) return [];
  const v = String(parseOrg(emp)[field] || '').trim();
  return v ? [v] : [];
}

export function grantMatchesEmp(grant, emp) {
  if (!grant || !emp) return false;
  const type = String(grant.subjectType || '').trim();
  if (!ORG_FIELD[type] && type !== 'employee') return false;
  const ids = Array.isArray(grant.subjectIds) ? grant.subjectIds : [];
  if (ids.includes(ALL_SUBJECTS)) {
    if (type === 'employee') return true;
    return subjectValues(emp, type).length > 0;
  }
  const mine = new Set(subjectValues(emp, type).map((s) => s.toLowerCase()));
  return ids.some((id) => mine.has(String(id || '').trim().toLowerCase()));
}

export function grantedPageKeys(emp, grants) {
  const keys = new Set();
  if (!emp || !Array.isArray(grants)) return keys;
  grants.forEach((g) => {
    if (!grantMatchesEmp(g, emp)) return;
    (g.pageKeys || []).forEach((k) => {
      if (PAGE_KEY_SET.has(k)) keys.add(k);
    });
  });
  return keys;
}

export function canAccessPage(emp, pageKey, grants) {
  if (isHardcodedAllowed(emp, pageKey)) return true;
  if (!emp || !pageKey || !Array.isArray(grants) || !grants.length) return false;
  return grants.some(
    (g) => (g.pageKeys || []).includes(pageKey) && grantMatchesEmp(g, emp)
  );
}

export function pageKeyFromPath(pathname) {
  if (!pathname) return null;
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return PAGE_PATH_TO_KEY[path] || null;
}

export const MANAGE_GROUP_KEYS = [
  'manageDept',
  'manageAdOrganization',
  'manageAssets',
  'baiboonAdmin',
  'manageChatId',
];

/** เมนูย่อยใต้กลุ่ม สมัครงาน ใน sidebar — ซ่อนหัวข้อถ้าไม่มีสิทธิ์ข้อใดเลย */
export const RECRUIT_GROUP_KEYS = [
  'listRecruit',
  'manageTest',
  'candidateEvaluation',
  'deptOpen',
  'applicationArchive',
];

/** เมนูย่อยใต้กลุ่ม ข้อมูลพนักงาน — ซ่อนหัวข้อถ้าไม่มีสิทธิ์ข้อใดเลย */
export const EMPLOYEE_GROUP_KEYS = [
  'manageUser',
  'consent',
  'manageHealth',
  'manageWelfare',
  'promoteCandidate',
  'prepareAssignAsset',
  'reqEmployee',
  'approveReqList',
];

/** Sidebar parent stays visible when any child is allowed (or the group has public children). */
export function navParentVisible(title, hasPage, emp) {
  if (title === 'ข้อมูลพนักงาน') return EMPLOYEE_GROUP_KEYS.some(hasPage);
  if (title === 'การจัดการ') return MANAGE_GROUP_KEYS.some(hasPage) || isPageAccessAdmin(emp);
  if (title === 'สมัครงาน') return RECRUIT_GROUP_KEYS.some(hasPage);
  return true;
}
